import get from 'lodash/get';

/**
 *
 * @param results
 * @returns {{pageNumber: undefined, numberOfElements: undefined, pageSize: undefined, totalElements: undefined}}
 */
export default function parsePagedResults(results) {
  return parsePagedData(get(results, ['data']));
}

/**
 *
 * @param results
 * @returns {{pageNumber: undefined, numberOfElements: undefined, pageSize: undefined, totalElements: undefined}}
 */
export function parsePagedData(results) {
  const totalElements = get(results, ['totalElements'], get(results, ['page', 'totalElements']));
  const numberOfElements = get(results, ['numberOfElements'], get(results, ['page', 'numberOfElements']));
  const pageNumber = get(results, ['pageable', 'pageNumber'], get(results, ['page', 'number']));
  const pageSize = get(results, ['pageable', 'pageSize'], get(results, ['page', 'size']));

  return {
    pageNumber,
    pageSize,
    totalElements,
    numberOfElements,
  };
}
